export const supportedLanguages = ['zh-CN', 'en'] as const

export type SupportedLanguage = (typeof supportedLanguages)[number]

export const languageOptions: { value: SupportedLanguage; label: string }[] = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en', label: 'English' },
]

export function normalizeLanguage(language?: string | null): SupportedLanguage | undefined {
  if (!language) return undefined

  const normalized = language.trim().replace(/_/g, '-')
  const lower = normalized.toLowerCase()

  if (
    lower === 'zh' ||
    lower === 'zh-cn' ||
    lower === 'zh-sg' ||
    lower.startsWith('zh-hans')
  ) {
    return 'zh-CN'
  }

  if (lower === 'en' || lower.startsWith('en-')) {
    return 'en'
  }

  const matched = supportedLanguages.find((lang) => lang.toLowerCase() === lower)
  return matched
}

export function getDocumentLang(language: string): string {
  return language.startsWith('zh') ? 'zh-CN' : 'en'
}
